import script from "./phoneView.vue?vue&type=script&setup=true&lang=js"
export * from "./phoneView.vue?vue&type=script&setup=true&lang=js"

import "./phoneView.vue?vue&type=style&index=0&id=0ca31f8c&lang=css"

const __exports__ = script;

export default __exports__